import React from 'react';

export default function Footer() {
    return (
        <footer className="bg-black small text-center text-white-50">
            <div className="container">
                Copyright &copy; Techno-Zone ITcare 2020. All rights reserved.
                <span className="text-white">
                Made in <span role="img" aria-label="heart">❤️</span> with
                    <span role="img" aria-label="india"> 🇮🇳</span>
                </span>.
            </div>
        </footer>
    );
}
